import { styled } from 'stitches.config'

export const ReviewsRoot = styled('div', {
  backgroundColor: '$primary-800',
  paddingTop: '$8',
})

export const ImageContainer = styled('div', {
  position: 'relative',
  size: '100px',

  '@bp3': {
    size: '200px',
  },
})

export const HeroSection = styled('section', {
  maxWidth: '$max',
  paddingTop: '$3',
  marginTop: '$8',
  px: '$3',

  '@bp3': {
    px: '$9',
    marginTop: '$15',
  },
})

export const ReviewHero = styled('div', {
  maxWidth: '400px',
  margin: 'auto',
  marginTop: '$3',
  textAlign: 'center',

  '@bp3': {
    maxWidth: 'initial',
    position: 'absolute',
    top: '$15',
    right: 0,
    width: '630px',
  },
})

export const ReviewPattern = styled('div', {
  position: 'absolute',
  right: 0,
  top: '600px',
  width: '260px',
  transform: 'translate(0%, 50%)',

  '@bp3': {
    top: '$15',
    width: '500px',
  },
})

export const Masonry = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '32px',
  marginTop: '$8',

  '@bp3': {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
})

export const Column = styled('div', {
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  gap: '32px',

  variants: {
    warped: {
      true: {
        '@bp3': {
          top: '64px',
        },
      },
    },
  },
})

export const BenefitsSection = styled('section', {
  borderTopLeftRadius: '72px',
  borderTopRightRadius: '72px',
  backgroundColor: '$secondary-100',
  paddingTop: '$12',
  paddingBottom: '190px',
})

export const BenefitsImage = styled('div', {
  display: 'none',
  position: 'absolute',
  width: '580px',
  left: '-$10',

  '@bp3': {
    display: 'initial',
  },
})

export const Claim = styled('div', {
  py: '$2',
  width: '328px',

  '@bp2': {
    width: '378px',
  },
})

export const ImagineSection = styled('section', {
  backgroundColor: '$secondary-100',
  position: 'relative',
})

export const ImagineImage = styled('div', {
  maxWidth: '300px',
  margin: 'auto',
  position: 'initial',
  marginTop: '$3',

  '@bp3': {
    position: 'absolute',
    top: '-$15',
    right: '$9',
    width: '480px',
    maxWidth: 'initial',
  },
})

export const ImagineSectionContent = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  borderTopLeftRadius: '72px',
  borderTopRightRadius: '72px',
  backgroundColor: '$secondary-300',
  px: '$12',
  paddingTop: '$10',
  paddingBottom: '$8',

  '& h2, & a': {
    textAlign: 'center',
  },

  '@bp3': {
    alignItems: 'flex-start',

    '& h2, & a': {
      textAlign: 'left',
    },
  },
})

export const TrustpilotContent = styled('div', {
  zIndex: 1,
  position: 'relative',
})
